module.exports = __webpack_public_path__ + "static/media/Gotham-Book.c1ab0f91.ttf";